export const SET_TITLE = "SET_TITLE";

export const mutations = {
  [SET_TITLE](state, title) {
    state.title = title;
  },
};
